<div id="spinner-wrapper" class="d-flex justify-content-center align-items-center" *ngIf="showSpinner | async">
  <div class="spinner-border text-white" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
